document.addEventListener('DOMContentLoaded', function() {
    const cartLink = document.querySelector('a.ig-header__cart.js-contents');
    const cartDrawer = document.querySelector('cart-drawer');
    const drawerClose = document.querySelector('.drawer__close');

    if (cartLink && cartDrawer) {
        cartLink.addEventListener('click', function(event) {
            event.preventDefault();
            cartDrawer.classList.add('active');
        });

        // Close when clicking the close button
        if (drawerClose) {
            drawerClose.addEventListener('click', function() {
                cartDrawer.classList.remove('active');
            });
        }

        // Close when clicking outside the cart drawer
        document.addEventListener('mousedown', function(event) {
            if (
                cartDrawer.classList.contains('active') &&
                !cartDrawer.contains(event.target) &&
                event.target !== cartLink
            ) {
                cartDrawer.classList.remove('active');
            }
        });

        // Close with ESC key
        document.addEventListener('keydown', function(event) {
            if (
                cartDrawer.classList.contains('active') &&
                (event.key === 'Escape' || event.key === 'Esc')
            ) {
                cartDrawer.classList.remove('active');
            }
        });
    }
});
